import React, {FC} from 'react';
import {ReactComponent as ExportXlsSvg} from 'resources/icons/export_xls.svg';
import {makeStyles} from '@material-ui/core';

export const ExportXlsYellowIcon: FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.iconContainer}>
      <ExportXlsSvg className={classes.yellowIcon} />
    </div>
  );
};

const useStyles = makeStyles(() => ({
  iconContainer: {
    position: 'relative',
    display: 'inline-block',
    borderRadius: '4px',
    padding: '2px',
    background: 'linear-gradient(145deg, #FF7700, #FF5500)',
    boxShadow: '0 2px 8px rgba(255, 119, 0, 0.4), 0 1px 3px rgba(255, 119, 0, 0.3)',
    border: '1px solid #FF7700',
  },
  yellowIcon: {
    display: 'block',
    filter: 'drop-shadow(0 1px 2px rgba(255, 119, 0, 0.5))',
  },
}));
